import { Amplify } from 'aws-amplify';
import { fetchAuthSession, getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { useState } from 'react';
import { amplifyConfig, initialUrlKey } from 'src/auth-config';
import { type User } from 'src/types';
import { useTranslation } from 'src/arb-wrapper';

Amplify.configure(amplifyConfig);

export const useAuth = () => {
  const { t } = useTranslation();
  const [user, setUser] = useState<User | null>(null);
  const [authError, setAuthError] = useState<string>();

  const savePathToLocalStorage = () => {
    localStorage.setItem(initialUrlKey, window.location.pathname);
  };

  const getUser = async (): Promise<User | null> => {
    try {
      await getCurrentUser();
      const { tokens } = await fetchAuthSession();
      const idPayload = tokens?.idToken?.payload;
      const user: User = {
        username: idPayload?.preferred_username as string,
        givenName: idPayload?.given_name as string,
        familyName: idPayload?.family_name as string,
        email: idPayload?.email as string,
      };

      setUser(user);
      return user;
    } catch (error) {
      // error is expected here if the user is not signed in
    }
    return null;
  };

  const signIn = () => {
    const unsubscribe = Hub.listen('auth', ({ payload: { event } }) => {
      const redirectUrl = localStorage.getItem(initialUrlKey) ?? '/';
      switch (event) {
        case 'signInWithRedirect':
          window.location.replace(redirectUrl);
          break;
        case 'signInWithRedirect_failure':
          setAuthError(t('oauth_failure'));
          break;
      }
    });

    getUser().then((user: User | null) => {
      if (!user) {
        savePathToLocalStorage();
        signInWithRedirect({ provider: { custom: 'FederateMidway' } });
      }
    });

    return unsubscribe;
  };

  return { user, authError, signIn, signOut };
};
